import React, { useEffect } from "react";
import { Button, InputSelect, PageHeader } from "../../../../components/";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { LearningPathValidator } from "./learningPathValidator";
import { CloseIcon, RightIcon, SelectIcon } from "../../../../assets/";
import {
  learningPathHeaderWrapper,
  learningPathButtonElement,
  learningPathMainWrapper,
  learningPathButtonWrapper,
  closeIcon,
  learningPathInputWrapper,
  learningPathWrapper,
} from "./learningPath.module.css";

const LearningPath = (props) => {
  const history = useHistory();

  const gotoNext = () => {
    props.onNext("others", values);
    history.push(`${history.location.pathname}#extras`);
  };

  const { errors, values, handleChange, handleSubmit, setValues, touched } =
    useFormik({
      initialValues: {
        learning_path: "",
      },
      validationSchema: LearningPathValidator,
      onSubmit: gotoNext,
    });

  const gotoPrev = () => {
    props.onNext("others", values);
    setValues((values) => ({ ...values, values }));
    history.goBack();
  };

  useEffect(() => {
    if (props && Object.keys(props.formData).length) {
      setValues({ ...props.formData });
    }
  }, [props, setValues]);

  return (
    <div className={learningPathWrapper}>
      <div className={learningPathMainWrapper}>
        <div className={learningPathHeaderWrapper}>
          <PageHeader
            head="Learning Path"
            text="Your tech journey begins here! Please select your desired learning path."
          />
          <img
            className={closeIcon}
            src={CloseIcon}
            alt=""
            onClick={() => history.push("/")}
          />
        </div>
        <div className={learningPathInputWrapper}>
          <InputSelect
            label="What is your choice career path?"
            placeholder="Select a desired learning path"
            onChange={handleChange}
            name="learning_path"
            value={values.learning_path}
            errorText={touched.learning_path ? errors.learning_path : ""}
            options={[
              { value: "product-design", name: "Product Design (UI/UX)" },
              { value: "backend-development", name: "Backend Development" },
              { value: "frontend-development", name: "Frontend Development" },
              { value: "web-3", name: "Web3" },
              { value: "data-analysis", name: "Data Analysis" },
              { value: "digital-marketing", name: "Digital Marketing" },
              { value: "quality-assurance", name: "Quality Assurance" },
              { value: "product-management", name: "Product Management" },
              { value: "game-development", name: "Game Development" },
              { value: "cybersecurity", name: "Cybersecurity" },
              { value: "project-management", name: "Project Management" },
            ]}
            icon={<SelectIcon />}
          />
        </div>
      </div>
      <div className={learningPathButtonWrapper}>
        <Button
          buttonName="Personal Data"
          className={learningPathButtonElement}
          onClick={() => gotoPrev()}
        />
        <Button
          main="fill"
          buttonName="Next - payments"
          className={learningPathButtonElement}
          onClick={handleSubmit}
          icon={<RightIcon />}
        />
      </div>
    </div>
  );
};
export { LearningPath };
